import React from "react";
import "./about.css";

const About = () => {
  return (
    <div class="main" id="about">
      <h1 id="aboutMe">ABOUT ME</h1>
      <div class="container">
        <h1 class="item1">Get To Know Me </h1>
        <span class="desc">
          Hello! <br />
          I'm <span class="highlight">Thasneem Shyju</span>, a self taught
          frontend developer with a passion for crafting engaging and intuitive
          user experiences. I took my
          <span class="highlight"> Bachelors in Computer Science</span> and got
          placed in Accenture through campus recruitment and had to drop my
          career for my family. I am a mom of 2, who spend most of the time for
          the family but had a strong passion to learn and update myself.
          <br />
          <br />I specialize in
          <span class="highlight"> HTML,CSS & JavaScript</span>, with expertise
          in popular framework like<span class="highlight"> React</span>. I am
          also experienced in{" "}
          <span class="highlight">
            responsive design, cross-browser compatibility
          </span>
          , and version control systems like <span class="highlight">Git</span>.
          I'm deeply
          passionate about creating seamless digital experiences that delight
          users.
          <br />
          <br />
          In the future, I aim to further refine my skills, collaborate with
          talented teams, and contribute to projects that make a meaningful
          impact. I'm thrilled to continue my journey in frontend development,
          constantly learning and pushing the boundaries of what's possible.If
          you are looking for a dedicated and innovative frontend developer, I'd
          love to connect and explore how we can work together.{" "}
        </span>
      </div>
      <div class="container1">
        <h1 class="item2">Skills/ Tech Used</h1>
        <button>HTML</button>
        <button>CSS</button>
        <button>JavaScript</button>
        <button>React</button>
        <button>BootStrap</button>
        <button>Tailwind CSS</button>
        <button>Material UI</button>
        <button>GIT</button>
        <button>GitHub</button>
        <button>Jenkins</button>
        <button>Agile</button>
        <button>Responsive design</button>
      </div>
    </div>
  );
};
export default About;
